import api, { apiErr } from "@/lib/api";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export { api, apiErr };

export const STATUS_COLORS = {
  confirmed: "bg-green-100 text-green-800", pending_approval: "bg-amber-100 text-amber-800",
  rescheduled: "bg-blue-100 text-blue-800", completed: "bg-[#E6DEC3] text-[#635B52]",
  balance_due: "bg-orange-100 text-orange-800",
  cancelled: "bg-red-100 text-red-700", pending: "bg-amber-100 text-amber-800", converted: "bg-green-100 text-green-800",
};

export const Badge = ({ s }) => (
  <span className={`text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap ${STATUS_COLORS[s] || "bg-gray-100 text-gray-700"}`}>{s?.replace(/_/g, " ")}</span>
);

export const inputCls = "w-full rounded-lg border border-[#E6DEC3] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B87333]/30 bg-white";
export const labelCls = "text-xs font-medium text-[#635B52]";
